import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import { Accordion, AccordionDetails, AccordionSummary, Box } from '@mui/material'
import CustomGrid from 'common/components/CustomGrid'
import 'dayjs/locale/es'
import WorkerCard from './WorkerCard'

const WorkersAccordion = ({ workers, actions }) => {
  return workers?.map((group) => {
    const employees = group.employees?.filter((employee) => !employee.hide) || []

    return (
      <Accordion defaultExpanded key={`wrkr-acc-${group.id}`}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls={`group${group.id}-content`}
          id={`group${group.id}-header`}
          key={`group${group.id}-header`}
        >
          {group.description}
        </AccordionSummary>
        <AccordionDetails>
          <CustomGrid
            dataSource={employees}
            count={employees?.length}
            gridItemsProps={{ size: { xs: 12, md: 3, sm: 6 } }}
            CardLayout={({ data: employee }) => <WorkerCard datos={employee} actions={actions} />}
            gridProps={{ spacing: 2 }}
          />
          {group.children ? (
            <Box key={`sub_group_${group.id}`}>
              <WorkersAccordion workers={group.children} actions={actions} />
            </Box>
          ) : null}
        </AccordionDetails>
      </Accordion>
    )
  })
}

export default WorkersAccordion
